import {
  login,
  register,
  fetchProfile,
  changeEmail,
  changePassword,
  updateProfile,
  refresh,
} from "@/api/auth";

const getDefaultState = () => ({
  token: window.localStorage.getItem("token"),
  refreshToken: window.localStorage.getItem("refreshToken"),
  profile: null,
});

export const auth = {
  state: getDefaultState(),
  getters: {
    isAuthenticated: (state) => !!state.token && !!state.profile,
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      window.localStorage.setItem("token", token);
    },
    SET_REFRESH_TOKEN(state, refreshToken) {
      state.refreshToken = refreshToken;
      window.localStorage.setItem("refreshToken", refreshToken);
    },
    SET_PROFILE(state, profile) {
      state.profile = profile;
    },
    LOGOUT(state) {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("refreshToken");
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async login({ commit, dispatch }, payload) {
      try {
        const { data } = await login(payload);
        commit("SET_TOKEN", data.token);
        commit("SET_REFRESH_TOKEN", data.refreshToken);
        return dispatch("fetchProfile");
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async register({ commit, dispatch }, payload) {
      try {
        const { data } = await register(payload);
        commit("SET_TOKEN", data.token);
        commit("SET_REFRESH_TOKEN", data.refreshToken);
        return dispatch("fetchProfile");
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchProfile({ commit }) {
      try {
        const { data } = await fetchProfile();
        commit("SET_PROFILE", data);
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async refresh({ state, commit }) {
      try {
        const { data } = await refresh({
          refreshToken: state.refreshToken,
        });
        commit("SET_TOKEN", data.token);
        commit("SET_REFRESH_TOKEN", data.refreshToken);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async changeEmail({ commit }, payload) {
      try {
        const { data } = await changeEmail(payload);
        commit("SET_PROFILE", data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async changePassword({ commit }, payload) {
      try {
        const { data } = await changePassword(payload);
        commit("SET_PROFILE", data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async updateProfile({ commit }, payload) {
      try {
        const { data } = await updateProfile(payload);
        commit("SET_PROFILE", data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
